import React, { useEffect, useState, useContext } from 'react'
import withWidth, { isWidthDown, WithWidth } from '@material-ui/core/withWidth'
import { compose } from 'recompose'
import ActivityLogModalStyles from './ActivityLogModal.styles'
import Spinner from 'Components/Spinner/Spinner.component'
import ModalComponent from 'Components/Modal/Modal.component'
import ServicesContext from 'Contexts/Services/Services.context'
import ActivityLogItemContainerComp from './parts/ActivityLogItemContainerComp'
import { Order } from 'types/Order'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps'
import { OrderActivityLog } from 'types/OrderActivityLog'
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'

interface Props {
  isOpen: boolean,
  order: Order,
  onClose(): void,
}

type FProps = Props & WithGlobalStylesProps<any> & WithWidth

const ActivityLogModalComp = (props: FProps) => {
  const {
    isOpen,
    order,
    onClose,

    classes,
    width,
  } = props

  const services = useContext(ServicesContext)
  const fullScreen: boolean = isWidthDown(`sm`, width)
  const [activityLog, setActivityLog] = useState<OrderActivityLog[]>([])
  const [isActivityLogLoading, setActivityLogLoading] = useState<boolean>(true)
  const [errorOccured, setErrorOccured] = useState<boolean>(false)

  useEffect(() => {
    (async () => {
      try {
        setActivityLog(await services.orderService.getActivityLog(order))
      } catch (ex) {
        setErrorOccured(true)
      }
      setActivityLogLoading(false)
    })()
  }, [])

  return (
    <ModalComponent
      title={`Activity`}
      width={width}
      onClose={onClose}
      open={isOpen}
      paperScrollPaper={false}
      dialogContentClasses={classes.dialogContent}
      content={
        isActivityLogLoading ? (
          <Spinner />
        ) : (
          <ActivityLogItemContainerComp
            logList={activityLog}
            errorOccured={errorOccured}
          />
        )
      }
    />
  )
}

export default compose<FProps, Props>(
  withWidth(),
  withGlobalStyles(ActivityLogModalStyles),
)(ActivityLogModalComp)
